import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { SiteMetadata, SiteMetadataProvider as Provider } from '@shapeable/web';

const SITE_METADATA_QUERY = graphql`
  query ThemeShapeableWeb_SiteMetaData {
    site {
      siteMetadata {
        name
        title
        titleTemplate
        twitter
        facebook
        flickr
        linkedin
        tiktok
        youtube
        instagram
        description
        image
        video
        twitter
      }
    }
  }
`;

export const SiteMetadataProvider: React.FC<any> = ({ children }) => {
  const { site } = useStaticQuery<{ site: { siteMetadata: SiteMetadata } }>(SITE_METADATA_QUERY);
  const { siteMetadata } = site;
  return <Provider value={siteMetadata}>{children}</Provider>;
};